import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';
import {
  TAdvancedFilterFlag,
  TAdvancedFilterSingle,
  TFilterFlagOptions,
} from '../../../../models/advanced-filter.model';
import { flaggedOperatorOptions } from '../../../../utils/advanced-filter-operator.utils';
import { EAdvancedFilterType } from '../../../../models/advanced-filter-type.enum';

@Component({
  selector: 'pp-advanced-filter-flag',
  templateUrl: './advanced-filter-flag.component.html',
  styleUrls: ['./advanced-filter-flag.component.scss'],
  standalone: false,
})
export class AdvancedFilterFlagComponent {
  @Input() ppFilter: TAdvancedFilterSingle;
  @Output() ppFilterChange = new EventEmitter<TAdvancedFilterSingle>();

  option: TFilterFlagOptions;
  filter: TAdvancedFilterFlag;

  advancedFilterFlagOptions = flaggedOperatorOptions;
  EAdvancedFilterOptions = EAdvancedFilterOptions;

  ngOnChanges(): void {
    const firstValue = this.ppFilter?.value?.[0];
    const hasSelectedIsNotFlagged = firstValue === 'false' || firstValue === false;

    if (hasSelectedIsNotFlagged) {
      const newFilter: TAdvancedFilterFlag = {
        ...this.ppFilter,
        type: EAdvancedFilterType.FLAGGED,
        option: EAdvancedFilterOptions.IS_NOT_FLAGGED,
        value: false,
      };
      this.filter = newFilter;
    } else {
      this.filter = this.ppFilter as TAdvancedFilterFlag;
    }

    this.option = this.filter.option;
  }

  changeFieldCondition(newCondition: TSelectOption): void {
    this.ppFilter.value = newCondition.data;
    this.ppFilter.operator = newCondition.operator;

    this.applyChanges();
  }

  applyChanges(): void {
    this.ppFilterChange.emit(this.ppFilter);
  }
}
